@for (tag of tags; track tag) {
    @if (tag !== 'null' && tag !== null && tag.length) {
        <span
            [ngClass]="heroImage ? 'tag-hero-image' : 'tag'"
            [class.tag-parent-hover]="mouseHoveringParent"
            (click)="click(tag); $event.stopPropagation()"
            >{{ tag }}
        </span>
    }
}
